function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 41.84 45.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-446.96,356.25l-8.54-8.55c-.86-.84-2.22-.84-3.08,0-.41,.41-.65,.97-.65,1.55s.23,1.14,.65,1.55l8.54,8.54c.82,.82,1.93,1.29,3.09,1.29s2.27-.46,3.09-1.29l20.17-20.17c.41-.41,.64-.96,.64-1.54s-.23-1.13-.64-1.54c-.41-.41-.96-.64-1.54-.64s-1.13,.23-1.54,.64l-20.19,20.17Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -470.12,
    y: 402.37,
    width: 55.37,
    height: 55.37,
    rx: -179.7,
    ry: -179.7,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -372.43,
    cy: 430.06,
    r: 28.2,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M32.24,45.83H9.6c-5.3,0-9.6-4.31-9.6-9.6V9.6C0,4.31,4.31,0,9.6,0h22.64c5.3,0,9.6,4.31,9.6,9.6v26.62c0,5.3-4.31,9.6-9.6,9.6ZM9.6,4c-3.09,0-5.6,2.51-5.6,5.6v26.62c0,3.09,2.51,5.6,5.6,5.6h22.64c3.09,0,5.6-2.51,5.6-5.6V9.6c0-3.09-2.51-5.6-5.6-5.6H9.6Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 8.75,
    y1: 18.53,
    x2: 8.75,
    y2: 31.33,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.47,
    y1: 14.59,
    x2: 23.47,
    y2: 27.22,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.92,
    y1: 20.07,
    x2: 29.92,
    y2: 27.31,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.1,
    y1: 20.18,
    x2: 28.11,
    y2: 20.18,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.84,14.5c-2.92,0-2.92,2.89-2.92,2.89v3.42",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86,27.22h2.55s2.03-.1,2.03-2.08,0-1.76,0-1.76v-2.78c0-1.98-2.03-2.08-2.03-2.08h-2.55",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.24,18.53h-2.55s-2.03,.1-2.03,2.08,0,1.76,0,1.76v2.78c0,1.98,2.03,2.08,2.03,2.08h2.55",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.2021581b.svg";
export { ForwardRef as ReactComponent };